/**
 * Co-Producer / Touring Partner / Project Partner form
 */

// import $ from 'jquery';
import Vue from 'vue';
import $ from 'jquery';
// import VeeValidate, { Validator } from 'vee-validate';
import VeeValidate from 'vee-validate';
import refreshToken from '../mixins/refresh-token';

Vue.use(VeeValidate);

const formAuthorizationComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-authorization',

    props: [
        // 'authorizationData',
        'token',
        'previous',
        'action',
        'id',
        'categorie',
        'readOnly',
        'year'
    ],

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = { tokenVal: null };

        return dataObject;
    },

    methods: {
        validateForm (e) {
            e.preventDefault();
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    let btnSpinner = $('.btn--spinner', e.target);

                    btnSpinner.addClass('right-spin');
                    e.target.submit();
                } else {
                    let fieldName = this.errors.items[0].field;

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('[name="' + fieldName + '"]').parent()
                            .offset().top - 130
                    }, 500);
                }
            })
                .catch(() => {
                    return false;
                });
        }
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        let errorMEssage = 'Must be ticked to submit';

        this.$validator.dictionary.merge({
            en: {
                custom: {
                    'authorization[correct_information]': { required: errorMEssage },
                    'authorization[lead_company_member_fedora]': { required: errorMEssage },
                    'authorization[information_can_be_shared]': { required: errorMEssage },
                    'authorization[fedora_communication]': { required: errorMEssage },
                    'authorization[crowdfunding_campaign]': { required: errorMEssage },
                    'authorization[agreement_contract]': { required: errorMEssage },
                    'authorization[co_producing_join_fedora]': { required: errorMEssage },
                    'authorization[lead_company_bank_account]': { required: errorMEssage },
                    // 'authorization[jury_evaluation]': { required: errorMEssage }
                    'authorization[event_launch]': { required: errorMEssage }
                }
            }
        });

        this.tokenVal = this.token;
    }

};

const formAuthorizationComponent = Vue.extend(formAuthorizationComponentConfig);

export default formAuthorizationComponent;
